import { Directive, Input, EventEmitter, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { filter, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CustomComponent } from '@cakeiteasy/web-utils';

import { CartState, getCart, ICart, IDispatchCartOptions } from '../../../cart';
import { CartEventsService } from '../../../cart/services/cart-events.service';
import { CartServiceV2 } from '../../../cart/services/cart-v2.service';
import { ICakeCartLine } from '../../../cart/models/cart/i-cake-cart-line';

@Directive({ standalone: false })
export class CartBaseWrapperComponent extends CustomComponent {
  @Input() showDeliveryEdit: boolean;
  @Input() showReturnEdit: boolean;

  @Output() onAddMoreClick = new EventEmitter<void>();
  @Output() onContinue = new EventEmitter<void>();
  @Output() onEditDelivery = new EventEmitter<void>();
  @Output() onEditReturn = new EventEmitter<void>();

  public cart: ICart;
  public cart$: Observable<ICart>;

  protected constructor(
    protected _store: Store<CartState>,
    protected _cartEvents: CartEventsService,
    protected _cartService: CartServiceV2,
  ) {
    super();

    this.cart$ = this._store.pipe(
      select(getCart),
      filter((c) => Boolean(c)),
    );
    this._baseSubscribe();
  }

  public updateCount(line: ICakeCartLine, options?: IDispatchCartOptions) {
    this._cartService.saveProduct(line, options);
  }

  public removeProduct(line: ICakeCartLine) {
    this._cartService.removeCartLine(line.clientId).then(() => {
      this._store.pipe(select(getCart), filter(Boolean), take(1)).subscribe((cart) => {
        if (cart.lines.length === 0) {
          this._cartEvents.hideCart();
        }
      });
    });
  }

  public closeCart() {
    this._cartEvents.hideCart();
  }

  public clearCart() {
    this._cartService.resetCart();
  }

  private _baseSubscribe() {
    this.addSubscriber(this.cart$.subscribe((cart) => (this.cart = cart)));
  }
}
